import styled from 'styled-components'

export const Container = styled.div`
  display: grid;
  gap: ${props => props.theme.spacing.sp16};
  grid-template-columns: 400px 1fr;
  margin-top: ${props => props.theme.spacing.sp32};

  @media (max-width: 1120px) {
    grid-template-columns: 1fr;
  }
`

export const RowsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
`
